import { gsap } from '../vendor/gsap';
import { ScrollTrigger } from '../vendor/gsap/ScrollTrigger';
import transparentBeforeAnimation from '../lib/transparent-before-animation';

gsap.registerPlugin(ScrollTrigger);

const moduleSelector = '.internal-page-header-decor';
const moduleCallBack = (moduleElement, query, queryAll) => {
    const parentSectionElement = moduleElement.parentElement.closest('section');
    const path = queryAll('path');
    const timeline = gsap.timeline({
        scrollTrigger: {
            trigger: parentSectionElement,
            start: 'top 100%',
        },
    });
    transparentBeforeAnimation(moduleElement, timeline);
    timeline.fromTo(path, { opacity: '0', y: '10%' }, {
        opacity: '1', y: '0', duration: 0.2, stagger: 0.1, ease: 'ease-out',
    }, 'start+=0.3');
};

export { moduleSelector, moduleCallBack };
